(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dynamic-section-portal"] && !Shopify.designMode) return;
  try {
    
  /**
   * Section Portal Chain Component
   * Loads multiple external pages sequentially via a waterfall fetch.
   */
  if (!customElements.get('section-portal-chain')) {
    class SectionPortalChain extends HTMLElement {
      constructor() {
        super();
        this.blocks = Array.from(this.querySelectorAll('.portal-chain-item'));
        this.isInitialLoadTriggered = false;
      }

      connectedCallback() {
        if (this.blocks.length === 0) return;

        const observerOptions = {
          root: null,
          rootMargin: this.getAttribute('data-root-margin') || '600px',
          threshold: 0,
        };

        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.isInitialLoadTriggered) {
              this.isInitialLoadTriggered = true;
              this.startChainReaction();
            }
          });
        }, observerOptions);

        this.observer.observe(this);
      }

      async startChainReaction() {
        // Loop through blocks one by one (Sequential/Chained)
        for (const block of this.blocks) {
          await this.fetchAndInject(block);
        }

        this.observer.unobserve(this);
        console.log('Portal Chain: All fetches completed.');
      }

      async fetchAndInject(block) {
        const url = block.dataset.portalUrl;
        const selector = block.dataset.selector;
        const target = block.querySelector('.portal-chain-item__target');
        const loader = block.querySelector('.section-portal__status');

        if (!url || url.includes('undefined')) return;

        loader.style.display = 'flex';
        try {
          const response = await fetch(url);
          if (!response.ok) throw new Error(`Status: ${response.status}`);

          const htmlText = await response.text();
          const parser = new DOMParser();
          const externalDoc = parser.parseFromString(htmlText, 'text/html');
          const sourceElement = externalDoc.querySelector(selector);

          if (sourceElement) {
            target.innerHTML = sourceElement.innerHTML;

            // Re-trigger Shopify events per block
            document.dispatchEvent(
              new CustomEvent('shopify:section:load', {
                detail: { sectionId: block.id },
              })
            );
          }
        } catch (error) {
          console.error(`Portal Chain Error for ${url}:`, error);
        } finally {
          loader.remove();
        }
      }

      triggerManualLoad() {
        if (!this.isInitialLoadTriggered) {
          this.isInitialLoadTriggered = true;
          return this.startChainReaction();
        }
      }
    }

    customElements.define('section-portal-chain', SectionPortalChain);
  }

  // Custom JS

  // Keep your existing SectionPortalChain class definition...

  /**
   * NEW: Handle external redirects and direct URL entries
   * e.g., Coming from /products/abc to /#free_account_features
   */
  window.addEventListener('DOMContentLoaded', async () => {
    const targetId = window.location.hash;
    if (!targetId || targetId === '#') return;

    const portal = document.querySelector('section-portal-chain');
    const targetElement = document.querySelector(targetId);

    // If the hash exists but the element doesn't (it's inside the portal)
    if (portal && !targetElement) {
      console.log('Deep-link target missing. Waking up Portal chain...');

      // Add a loader state to the body if you want to prevent jumping
      document.body.classList.add('portal-searching');

      // Manually trigger the sequential fetch
      await portal.triggerManualLoad();

      // Poll for the element to appear
      const findAndScroll = () => {
        const newTarget = document.querySelector(targetId);
        if (newTarget) {
          // Delay slightly to ensure layout is calculated
          setTimeout(() => {
            newTarget.scrollIntoView({ behavior: 'smooth' });
            document.body.classList.remove('portal-searching');
          }, 100);
          return true;
        }
        return false;
      };

      // Check periodically if not found immediately
      let attempts = 0;
      const interval = setInterval(() => {
        attempts++;
        if (findAndScroll() || attempts > 50) {
          clearInterval(interval);
          document.body.classList.remove('portal-searching');
        }
      }, 100);
    }
  });

  /**
   * UPDATED: Optimized Click Listener for both relative and absolute URLs
   */
  document.addEventListener('click', async (e) => {
    const link = e.target.closest('a');
    if (!link) return;

    const href = link.getAttribute('href');
    if (!href || !href.includes('#')) return;

    // Split the URL to get the hash
    const urlParts = href.split('#');
    const targetId = '#' + urlParts[1];

    // If it's a link to the CURRENT page (e.g., just the ID or currentURL#ID)
    const isCurrentPage = href.startsWith('#') || href.startsWith(window.location.origin + window.location.pathname);

    if (isCurrentPage) {
      const targetElement = document.querySelector(targetId);

      if (!targetElement) {
        e.preventDefault();
        const portal = document.querySelector('section-portal-chain');

        if (portal) {
          console.log('Target not found on current page, waking up the Portal...');
          document.body.classList.add('portal-searching');

          await portal.triggerManualLoad();

          const findAndScroll = () => {
            const newTarget = document.querySelector(targetId);
            if (newTarget) {
              newTarget.scrollIntoView({ behavior: 'smooth' });
              document.body.classList.remove('portal-searching');
              // Update URL hash without jumping
              history.pushState(null, null, targetId);
              return true;
            }
            return false;
          };

          const interval = setInterval(() => {
            if (findAndScroll()) clearInterval(interval);
          }, 100);

          setTimeout(() => {
            clearInterval(interval);
            document.body.classList.remove('portal-searching');
          }, 5000);
        }
      }
    }
    // If it's NOT the current page (e.g., /products -> /#id),
    // allow the browser to redirect naturally. The DOMContentLoaded
    // listener above will catch it once the new page loads.
  });

  } catch(e) { console.error(e); }
})();
})();
